import {
  Computed,
  DataAction,
  Payload,
  Persistence,
  StateRepository,
} from '@angular-ru/ngxs/decorators';
import { NgxsDataRepository } from '@angular-ru/ngxs/repositories';
import { Injectable } from '@angular/core';
import { ExternalSessionModel } from '@core/models';
import { State } from '@ngxs/store';

const defaults = {
  accessToken: undefined,
};

@Persistence()
@StateRepository()
@State<ExternalSessionModel>({
  name: 'externalSession',
  defaults,
})
@Injectable()
export class ExternalSessionState extends NgxsDataRepository<ExternalSessionModel> {
  @Computed()
  public get accessToken(): string | undefined {
    return this.snapshot.accessToken;
  }

  @DataAction()
  public addSession(@Payload('session') accessToken: string): void {
    this.ctx.patchState({
      accessToken,
    });
  }

  @DataAction()
  public removeSession(): void {
    this.ctx.patchState({
      accessToken: undefined,
    });
  }
}
